import { DataBox, createDataBox } from 'app/common/data-box-store'


type SendersInfoParams = {}
const defaultSendersInfoParams = {} as const satisfies SendersInfoParams

class SendersInfoParamsDataBox extends DataBox<SendersInfoParams> { }
export const sendersInfoParams = createDataBox(
  'sendersInfoParams',
  defaultSendersInfoParams,
  SendersInfoParamsDataBox
)
